import React from 'react';

import styled from '@emotion/styled';
import { Checkbox as AntdCheckbox, CheckboxProps as AntdCheckboxProps } from 'antd';

import { PrimaryColors } from '../colors';

export type CheckboxSize = 'medium' | 'large';

interface CheckboxProps extends AntdCheckboxProps {
  size?: CheckboxSize;
}

const getCheckboxSize = (size: CheckboxSize = 'medium') => {
  switch (size) {
    case 'large':
      return 18;
    case 'medium':
    default:
      return 14;
  }
};

const getCheckboxRadius = (size: CheckboxSize = 'medium') => {
  switch (size) {
    case 'large':
      return 6;
    case 'medium':
    default:
      return 4;
  }
};

const StyledCheckbox = styled(AntdCheckbox)<{ $size: CheckboxSize }>`
  &.ant-checkbox-wrapper .ant-checkbox-inner {
    width: ${({ $size }) => getCheckboxSize($size)}px;
    height: ${({ $size }) => getCheckboxSize($size)}px;
    border-radius: ${({ $size }) => getCheckboxRadius($size)}px;
  }
  &.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${PrimaryColors.primary600} !important;
    border-color: ${PrimaryColors.primary600} !important;
  }
  &.ant-checkbox-wrapper .ant-checkbox-checked .ant-checkbox-inner:after {
    border-color: white;
  }
  &.ant-checkbox-wrapper .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${PrimaryColors.primary600};
  }
  &.ant-checkbox-wrapper .ant-checkbox-checked {
    &:hover .ant-checkbox-inner {
      background-color: ${PrimaryColors.primary600};
      border-color: ${PrimaryColors.primary600};
    }
  }
`;

export const Checkbox: React.FC<CheckboxProps> = ({ size = 'medium', ...props }) => {
  return <StyledCheckbox $size={size} {...props} />;
};
